(function() {
	"use strict";

	const navItems = document.querySelectorAll('.nav-item');
	
	function openSubNav(e) {
		// Grab nav wrapper
		const navWrapper = document.querySelector('.nav-home-wrapper');
		
		// Grab array of secondary menus
		const secondaryMenu = Array.from(document.querySelectorAll('.secondary-menu'));
		
		// Grab the menu name from the data-menu
		const menuName = this.getAttribute('data-menu');
		
		// Grab the correct secondary menu based on the link that was clicked
		const modifyMenu = document.querySelector(`.secondary-menu[data-menu="${menuName}"]`);
				
		secondaryMenu.forEach(secondaryMenu => secondaryMenu.classList.remove("active"));
		navItems.forEach(navItems => navItems.classList.remove("active"));

		navWrapper.setAttribute('data-bg', menuName); 		
		modifyMenu.classList.add('active');	
		this.classList.add('active');
	}
	
	navItems.forEach(navItems => navItems.addEventListener('click', openSubNav));
	
})();